import { useEffect } from 'react';
import DashboardAppService from '../../../../application/platform/ser/dashboard/dashboard-app-service';
import { useFeedback } from '../../../../hooks/use-feedback';
import { PeriodPreset, getPresetPeriod, isPeriodValid } from '../dashboard-period';
import { ACTION_TYPES, useDashboardDispatch, useDashboardState } from './dashboard-context';

export const useDashboardController = (clientId?: number) => {
    const dispatch = useDashboardDispatch();
    const state = useDashboardState();
    const { showError } = useFeedback();

    async function load() {
        if (!clientId || !isPeriodValid(state.startDate, state.endDate)) return;
        dispatch({ type: ACTION_TYPES.loadStart });
        try {
            dispatch({ type: ACTION_TYPES.loadSuccess, payload: await DashboardAppService.getOverview(state.startDate, state.endDate, clientId) });
        } catch (error: any) {
            dispatch({ type: ACTION_TYPES.loadError, payload: error?.message || 'Não foi possível carregar o painel' });
            showError('Não foi possível carregar o painel', error);
        }
    }

    useEffect(() => {
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientId, state.startDate, state.endDate]);

    function selectPreset(preset: Exclude<PeriodPreset, 'custom'>) {
        dispatch({ type: ACTION_TYPES.setPeriod, payload: { preset, ...getPresetPeriod(preset) } });
    }

    // Datas personalizadas: o painel só recarrega quando o intervalo fica completo e válido
    function changeDate(field: 'startDate' | 'endDate', value: string | null) {
        dispatch({ type: ACTION_TYPES.setPeriod, payload: { preset: 'custom', [field]: value ?? '' } });
    }

    return { load, selectPreset, changeDate };
};
